import { useState } from "react";
import { Search, Check } from "lucide-react";
import { imgUrl } from "@/lib/api";

export const PairPicker = ({ label, items, value, onPick, id }) => {
  const [q, setQ] = useState("");
  const [sup, setSup] = useState("");
  const suppliers = [...new Set(items.map((i) => i.supplier).filter(Boolean))].sort();
  const t = q.trim().toLowerCase();
  const shown = items.filter((i) => (!sup || i.supplier === sup) && (!t || `${i.name} ${i.code} ${i.supplier} ${i.style || ""}`.toLowerCase().includes(t)));

  return (
    <div className="min-w-0" data-testid={`pair-picker-${id}`}>
      <div className="flex flex-wrap items-center gap-2 mb-3">
        <p className="font-mono-j text-[11px] uppercase tracking-[0.25em] text-[#C5A059] mr-2">{label}</p>
        {["", ...suppliers].map((s) => (
          <button key={s || "all"} onClick={() => setSup(s)} data-testid={`pair-${id}-sup-${(s || "all").toLowerCase()}`}
            className={`h-8 px-3 rounded-full text-xs border transition-colors ${sup === s ? "bg-[#F5F3EF] text-[#0D0D11] border-[#F5F3EF]" : "border-[#D4AF37]/25 text-[#A09E97] hover:text-[#F5F3EF]"}`}>
            {s || "All"}
          </button>
        ))}
        <label className="relative ml-auto w-full sm:w-48">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-[#A09E97]" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={`Search ${label.toLowerCase()}`} data-testid={`pair-${id}-search`}
            className="w-full h-8 rounded-full bg-[#0D0D11] border border-[#D4AF37]/25 pl-8 pr-3 text-xs text-[#F5F3EF] focus:outline-none focus:border-[#D4AF37]" />
        </label>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-2" data-lenis-prevent>
        {shown.map((i) => (
          <button key={i.id} onClick={() => onPick(i)} title={`${i.name} · ${i.supplier}`} data-testid={`pair-${id}-option-${i.id}`}
            className={`relative shrink-0 w-20 sm:w-24 text-left group`}>
            <span className={`block aspect-square overflow-hidden border-2 transition-colors ${value?.id === i.id ? "border-[#D4AF37]" : "border-transparent group-hover:border-[#D4AF37]/40"}`}>
              <img src={imgUrl(i.images?.[0])} alt={i.name} loading="lazy" className="w-full h-full object-cover" />
            </span>
            {value?.id === i.id && <Check className="absolute top-1.5 right-1.5 w-5 h-5 p-0.5 rounded-full bg-[#D4AF37] text-[#0D0D11]" />}
            <span className="mt-1 block text-[11px] leading-tight text-[#A09E97] line-clamp-2">{i.name}</span>
          </button>
        ))}
        {shown.length === 0 && <p className="text-sm text-[#A09E97] py-6">No matches.</p>}
      </div>
    </div>
  );
};
